// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"921b055d","156":"678bbb61","338":"e4988b6c","551":"33b6a8ea","645":"c0ce0023","842":"a10e9250"}[chunkId] + ".chunk.js";
};